<template>
  <v-app class="rounded rounded-md">
    <MoleculesMyAppBar :admin-ui="true"/>
    <MoleculesAdminDrawer :on-item-click="onItemClick"/>
    <v-main class="bg-light-gray">
      <NuxtPage/>
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
import {useI18n} from "vue-i18n";
import {useAdminDrawerStore} from "~/stores/admin/drawer";
import type {DrawerElement} from "~/types/admin/drawer";

const {t} = useI18n()
const decathlonStore = useDecathlonStores()
const languageStore = useLanguageStore()
const userStore = useUserStore()
const {$open} = useNuxtApp()
const adminDrawerStore = useAdminDrawerStore()



const onItemClick = async (item: DrawerElement) => await navigateTo(item.url)

</script>
